import React from "react";
import { Link } from "react-router-dom";
import { eur } from "@/lib/format";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className="relative overflow-hidden bg-[#1C1917] border ee-hairline aspect-[4/5]">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-60" />
        <span className="absolute top-4 left-4 ee-overline">{product.category_name}</span>
      </div>
      <div className="pt-5">
        <h3 className="font-display text-2xl tracking-wide group-hover:text-[#D4AF37] transition-colors">
          {product.name}
        </h3>
        {product.inspired_by && (
          <p className="text-xs text-[#A8A29E] italic mt-1">{product.inspired_by}</p>
        )}
        <p className="ee-gold-text mt-3 text-lg">
          {product.variants?.length ? "From " : ""}
          {eur(product.price)}
          <span className="text-[#57534E] text-xs ml-2">excl. VAT</span>
        </p>
      </div>
    </Link>
  );
}
